import { render, staticRenderFns } from "./corpperImg2M.vue?vue&type=template&id=e6dd4702"
import script from "./corpperImg2M.vue?vue&type=script&lang=js"
export * from "./corpperImg2M.vue?vue&type=script&lang=js"
import style0 from "./corpperImg2M.vue?vue&type=style&index=0&id=e6dd4702&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports